import { getTableLang } from "../../Utils/Inits/getTableLang";
import { addCoursesToOpenInvitation } from "../../Utils/TutorManagement/activateNewCoursesToInvitation";
import { activateTutorForCourses } from "../../Utils/TutorManagement/activateTutorForCourses";
import { activateNewTutorForCourses } from "../../Utils/TutorManagement/inviteTutorToCourses";
import { removeCourseFromInvitation } from "../../Utils/TutorManagement/removeCourseFromInvitation";
import { removeExistingTutorInvitation } from "../../Utils/TutorManagement/removeExistingTutorInvitation";
import { removeInvitationsViaEmailFromInstance } from "../../Utils/TutorManagement/removeInvitationsViaEmailFromInstance";
import { removeTutorFromCourse } from "../../Utils/TutorManagement/removeTutorFromCourse";
import { removeTutorFromInstance } from "../../Utils/TutorManagement/removeTutorFromInstance";
import { removeTutorInvitation } from "../../Utils/TutorManagement/removeTutorInvitation";
import { saveTutorRightSettings } from "../../Utils/TutorManagement/saveTutorRightSettings";
import { checkEmail, chooseListWithButtons, errorToast, getCurrentTutorCourseIds, tutorVerwaltungGetTutorFromBadge, tutorVerwaltungGetTutorFromButton } from "../../Utils/utils";
import { loadDt } from "../AdminCourseManagement/loadDt";
import { fillTutorRightsModal } from "./fillTutorRightsModel";

export class TutorManager{
    schoolId:number;

    constructor(schoolId){
        this.schoolId = schoolId;
        this.chooseList1 = new chooseListWithButtons(".new-tutor-wrapper", ".m-f-t-item", ".add-course-to-be-activated");
        this.chooseList2 = new chooseListWithButtons("#add-courses-to-tutor-wrapper", ".m-f-t-item", ".add-course-to-be-activated");
        this.addListeners();
        this.table = $("#tutor-table")
        this.table.DataTable({
            language: getTableLang(['Tutor/-in', 'Tutor/-innen']),
            columnDefs: [
                {"orderable": false, "targets": [4,5,6]}
            ]
        })
    }

    addListeners(){
        const self = this;
        $("#activate-tutor-for-course").on("click", ".add-courses-to-tutor", function(){
            let email;
            const courses = self.chooseList2.getData();
            const userId = $(this).attr('data-user');

            let targetField = '';
            const rows = $("#activate-new-tutor-for-courses tbody tr");

            if (Number($(this).attr('data-not-accepted')) == 1){

                rows.each(function(ind, obj){
                    const thisUserId = $(obj).find(".tutor").attr('data-user');
                    if (thisUserId == userId){
                        email = $(obj).find(".tutor.not-accepted").attr('data-mail')
                    }
                });
                // if currently not accepted
                addCoursesToOpenInvitation(email, courses, self.schoolId, $(this))
            } else {

                rows.each(function(ind, obj){
                    const thisUserId = $(obj).find(".tutor").attr('data-user');
                    if (thisUserId == userId){
                        targetField = $(obj).find(".tutor-courses");
                    }
                });
                activateTutorForCourses(userId, courses, self.schoolId, targetField, $(this));
            }
        });
        $("#activate-new-tutor").on("click", ".activate-new-tutor-for-course", function(){ // activate new tutor for course

            const email = $("#new-tutor-mail").val();
            const check = checkEmail(email);
            const courses = self.chooseList1.getData();

            if (!check || email == ''){
                errorToast('Bitte gib eine gültige Mail ein', 'Fehler', 15000, true);
            } else if (courses.length < 1){
                errorToast('Bitte wähle mindestens einen Kurs aus', 'Fehler', 15000, true);
            } else {
                activateNewTutorForCourses(email, courses, self.schoolId, self.chooseList1, $(this)).done((result) => {
                    // remove
                    $("#new-tutor-mail").val("");
                    // click
                    $("button.close-new-tutor-modal").click();
                    self.chooseList1.resetData();
                    // now reload middle
                    location.reload();
                });
            }
        });
        $("#activate-new-tutor-for-courses").on("click", ".multiple-choose-form .m-f-t-item", function(){
            const check = $(this).find("checkbox")
            if (check.is(":checked")){
                check.prop('checked', true);
                $(this).addClass("chosen");
            } else {
                $(this).removeClass("chosen");
            }
        });
        $(".save-tutor-settings").on("click", function(){
            const userId = $("#tutor-settings-wrapper .minimal-flex-table").attr("data-user");
            const checkboxes = $("#tutor-settings-wrapper .toggle-rights");
            const rights = {}
            checkboxes.each(function(ind, obj){
                const rightId = $(obj).attr("data-right");
                rights[rightId] = $(obj).is(":checked");
            });
            saveTutorRightSettings(userId, self.schoolId, rights, $(this));
        });
        $("#set-tutor-settings").on("change", ".toggle-rights", function(){
            const checked = $(this).prop('checked');
            const button = $(this).parent().parent().parent().prev().find("button")

            const dangerClasses = "btn-light-danger text-danger";
            const successClasses = "btn-light-success text-success";
            if (checked){
                button.addClass(successClasses).removeClass(dangerClasses);
            } else {
                button.addClass(dangerClasses).removeClass(successClasses);
            }
        });

        $(".tutor-settings").on("click", function(){
            const myModalEl = document.getElementById("set-tutor-settings");
            const myModal = new bootstrap.Modal(myModalEl, {});
            myModal.show();

            const userId = $(this).data("user");
            // set to editing
            const parent = $(this).parent();
            $("#tutor-liste td.editing").removeClass("editing");
            parent.addClass("editing");

            // fill modal with ajax call
            fillTutorRightsModal(userId, self.schoolId, $("#tutor-settings-wrapper"));
        });

        $(".remove-tutor").on("click", function(){
            const btn = $(this)
            const tutor = tutorVerwaltungGetTutorFromButton($(this));
            const userId = tutor.id;
            const tutorName = tutor.name;
            const row = tutor.cell.parent();

            const confirmed = confirm("Bist du dir sicher, dass du " + tutorName + " komplett als Tutor/-in deaktivieren möchtest?");
            if (confirmed){
                if (btn.hasClass('not-accepted')){
                    const email = btn.parent().parent().find(".tutor.not-accepted").attr('data-mail')
                    removeInvitationsViaEmailFromInstance(email, self.schoolId, btn)
                        .done((result) => {
                            row.remove()
                        })
                } else {
                    removeTutorFromInstance(userId, self.schoolId, btn).done((result) => {
                        row.remove()
                    });
                }
            }
        });
        // Inits modal by only showing courses, that are not available yet
        $(".add-course-to-tutor").on("click", function(){
            const courseIds = getCurrentTutorCourseIds($(this));
            const coursesWrapper = $("#activate-tutor-for-course");
            const courses = coursesWrapper.find(".m-f-t-item button.add-course-to-be-activated");

            courses.each(function(ind, obj){
                const courseId = parseInt(obj.getAttribute('data-fach'));
                const item = $(obj).parent().parent();
                if (courseIds.includes(courseId)){
                    item.addClass("d-none");
                } else {
                    item.removeClass("d-none");
                }
            });
            self.chooseList2.resetData();

            const tutor = tutorVerwaltungGetTutorFromButton($(this));
            $("#add-courses-to-tutor-wrapper .t-name").html(tutor.name);
            $(".add-courses-to-tutor").attr('data-user', tutor.id);
            $(".add-courses-to-tutor").attr('data-not-accepted', $(this).hasClass('not-accepted') ? 1 : 0) // if the current button has class not-accepted -> set attribute to data-not-accepted
        });

        $("#activate-new-tutor-for-courses").on("click", ".remove-course-from-tutor", function(){
            const courseId = $(this).data("course");
            const courseName = $(this).prev().html();
            const tutor = tutorVerwaltungGetTutorFromBadge($(this))
            const userId = tutor.id;
            const tutorName = tutor.name;

            const confirmed = confirm("Bist du dir sicher, dass du " + tutorName + " als Tutor/-in vom Kurs " + courseName + " deaktivieren möchtest?");

            if (confirmed) {
                const badge = $(this).parents(".badge");
                if (badge.find(".t-info").hasClass('not-accepted')){
                    // the current tutor does not exist yet
                    const email = badge.parent().parent().find(".tutor.not-accepted").attr('data-mail')
                    console.log(email);
                    removeTutorInvitation(email, courseId)
                    .done((result) => {
                        badge.remove();
                    })
                } else {
                    // tutor exists
                    if (badge.hasClass('bg-inverse')){
                        removeExistingTutorInvitation(userId, courseId, false)
                            .done((result) => {
                                badge.remove()
                            });
                    } else {
                        removeTutorFromCourse(userId, courseId, false, false).
                            done((result) => {
                                badge.remove()
                        });
                    }
                }
            }
        });
    }
}